import { Search } from '@americanexpress/dls-react';
import LiteralsService from 'src/services/literals/LiteralsService';
import Selectors from 'src/utils/selectors';
import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import React from 'react';
import { useBreakpoints } from 'src/hooks/useBreakpoints';

interface Props {
    value: string;
    setSearch: (value: string) => void;
    handleSearch: (value: string) => void;
}

export default function TransactionsSearchInput({ value, setSearch, handleSearch }: Props): JSX.Element {
    const { isMinWidthLarge } = useBreakpoints();
    const placeholder = isMinWidthLarge
        ? LiteralsService.getLiteral('TransactionsView.searchPlaceholder')
        : LiteralsService.getLiteral('TransactionsView.searchPlaceholderShort');

    return (
        <Search
            // Override DLS
            // need to override default DLS aria attributes and role used for SearchResults pop up menu
            // incorrect for this use case, since we do not have a pop up menu
            role="searchbox"
            aria-haspopup={undefined}
            aria-invalid={undefined}
            aria-autocomplete={undefined}
            aria-required={undefined}
            aria-activedescendant={undefined}
            aria-expanded={undefined}
            aria-controls={undefined}
            placeholder={placeholder}
            value={value || ''} // manual value is needed for X button
            buttonSearch
            data-cy={Selectors.Transactions.SEARCH}
            id="transactionSearch"
            onClick={() => trackClick(location.pathname, adobeTags.Search.FieldFill)}
            onChange={(e: any) => {
                // DLS recommends using event type to identify when the user has clicked the
                // clear (x) button to clear the search field
                if (e.type === 'click') {
                    handleSearch('');
                    return;
                }
                setSearch(e.target.value);
            }}
            onSearch={() => handleSearch(value)}
        />
    );
}
